export const MIN_REVENUE = 'MIN_REVENUE';
export const MAX_REVENUE = 'MAX_REVENUE';
export const MIN_EMPLOYEES = 'MIN_EMPLOYEES';
export const MAX_EMPLOYEES = 'MAX_EMPLOYEES';